import { useEffect } from "react";
import { Instagram } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const INSTAGRAM_URL = "https://www.instagram.com/arabianalwahaksa";

const InstagramRedirect = () => {
  useEffect(() => {
    // Log the scan (fire-and-forget; do not block redirect on failure)
    supabase.from("qr_scans").insert({
      platform: "instagram",
      user_agent: navigator.userAgent,
      referrer: document.referrer || null,
    }).then(() => {}, () => {});

    const t = setTimeout(() => {
      window.location.replace(INSTAGRAM_URL);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/40 px-6">
      <noscript>
        <meta httpEquiv="refresh" content={`0; url=${INSTAGRAM_URL}`} />
      </noscript>
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-[#feda75] via-[#d62976] to-[#4f5bd5] flex items-center justify-center shadow-elegant animate-pulse">
          <Instagram className="w-10 h-10 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-primary mb-2">Redirecting to Instagram…</h1>
        <p className="text-muted-foreground mb-6">
          Taking you to <span className="font-medium">@arabianalwahaksa</span>
        </p>
        <a
          href={INSTAGRAM_URL}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-gradient-to-r from-[#d62976] to-[#4f5bd5] text-white font-medium hover:opacity-90 transition-opacity"
        >
          <Instagram className="w-4 h-4" />
          Open Instagram
        </a>
      </div>
    </main>
  );
};

export default InstagramRedirect;